<template>
  <HeaderCustom title="Gestão do Conhecimento">
    <v-row>
      <v-col>
        <CardParametrosConsulta />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <ResultadoConsulta v-show="totalElementos" />
      </v-col>
    </v-row>
  </HeaderCustom>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import CardParametrosConsulta from './components/consulta/CardParametrosConsulta.vue';
import ResultadoConsulta from './components/consulta/ResultadoConsulta.vue';
import { ConsultaJurisprudenciaSelecionadaStore } from './store/ConsultaJurisprudenciaSelecionadaStore';
import HeaderCustom from '../components/HeaderCustom.vue';
const store = ConsultaJurisprudenciaSelecionadaStore();

const { totalElementos } = storeToRefs(store);
</script>
